// src/app/services/auth.service.ts
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserRole } from '../enums/role.enum';
import { ApiEndpoints } from '../enums/api.enum';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private http: HttpService) { }

    getAllNotifications(data: any = {}): Observable<any> {
        return this.http.post(ApiEndpoints.GET_ALL_NOTIFICATIONS, data).pipe(
            tap((response: any) => {

            })
        );
    }

    updateNotificationStatus(data: any = {}): Observable<any> {
        return this.http.post(ApiEndpoints.UPDATE_NOTIFICATION_STATUS, data).pipe(
            tap(() => {

            })
        );
    }

    markAllNotificationsAsRead(): Observable<any> {
        return this.http.post(ApiEndpoints.UPDATE_NOTIFICATION, { mark_all_as_read: true }).pipe(
            tap(() => {

            })
        );
    }

}